import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { map } from 'rxjs';

import { GlobalService } from '@app/services/global.service';

@Component({
  selector: 'app-release-version',
  template: `
    @if (matchingRelease$ | async; as matchingRelease) {
      <strong>OD</strong>&nbsp;<span [title]="versions$ | async">v{{ matchingRelease.version }}</span>
    } @else {
      <strong>OD</strong>&nbsp;<span [title]="versions$ | async">NONE</span>
    }
  `,
  imports: [AsyncPipe],
})
export class ReleaseVersionComponent {
  private globalService = inject(GlobalService);

  matchingRelease$ = this.globalService.matchingRelease$;
  versions$ = this.globalService.versions$.pipe(map((versions) => `UI v${versions[0]} and MM v${versions[1]}`));
}
